import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBuilding, faHammer, faWrench } from '@fortawesome/free-solid-svg-icons';

const services = [
  {
    id: 1,
    title: 'Construction neuve',
    description: 'Réalisation de projets résidentiels et commerciaux avec les dernières normes de construction.',
    icon: faBuilding,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=2070&auto=format&fit=crop',
  },
  {
    id: 2,
    title: 'Rénovation',
    description: 'Transformation et modernisation de vos espaces existants pour une nouvelle vie.',
    icon: faHammer,
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=2071&auto=format&fit=crop',
  },
  {
    id: 3,
    title: 'Réparation et maintenance',
    description: 'Entretien et réparation de vos installations pour prolonger leur durée de vie.',
    icon: faWrench,
    image: '/assets/images/services/toiture-maintenance.jpg',
  }
];

const ServicesOverview: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Nos services d'excellence
          </h2>
          <p className="font-heading text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Découvrez notre gamme complète de services de construction et de rénovation adaptés à tous vos besoins.
          </p>
        </div>

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {services.map((service) => (
            <motion.div 
              key={service.id}
              className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              variants={itemVariants}
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <FontAwesomeIcon icon={service.icon} className="text-primary mr-2" />
                  <h3 className="font-heading text-xl font-semibold text-gray-900 dark:text-white">
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-600 dark:text-gray-300 mb-4">
                  {service.description}
                </p>
                <Link 
                  to={`/services#${service.id}`} 
                  className="inline-flex items-center font-medium text-primary dark:text-primary-light hover:underline"
                >
                  En savoir plus
                  <FontAwesomeIcon icon={faArrowRight} className="ml-2 text-sm" />
                </Link>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <div className="text-center mt-12">
          <Link 
            to="/services" 
            className="inline-flex items-center px-6 py-3 bg-primary hover:bg-primary-dark text-white font-heading font-medium rounded-md transition-colors duration-300"
          >
            Tous nos services
            <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
